import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-password-set',
    templateUrl: './password-set.component.html',
    styleUrls: ['./password-set.component.scss']
})
export class PasswordSetComponent implements OnInit, OnDestroy {
    form: FormGroup;
    resetData = {
        password: '',
        autoId: ''
    };
    notAuthorized = false;
    oldPasswordUsed = false;

    destroy$ = new Subject<void>()

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private fb: FormBuilder,
    ) {
        this.form = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(8)]],
            passwordConfirm: ['', [Validators.required, Validators.minLength(8)]]
        });

    }

    ngOnInit(): void {
        this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.oldPasswordUsed = false)

        this.resetData.autoId = this.route.snapshot.params.Id;
    }

    onSubmit() {
        this.resetData.password = this.form.value.password;
        this.authService.passwordSet(this.resetData).subscribe(data => {
            this.router.navigate(['/password', 'confirmation']);
        },
            (error) => {
                if (error.error.code === 'AUTH-0001') {
                    this.oldPasswordUsed = true
                } else {
                    this.notAuthorized = true;
                }
            });
    }
    get hasErrors() {
        return this.notAuthorized || this.oldPasswordUsed;
    }
    ngOnDestroy(): void {
        this.destroy$.next();
    }

}
